import React from 'react';
import { SECTION_NAMES } from './../../integrations/integration-log/IntegrationRequestOrResponseLogModal';
import { dateCreatedFormatter } from 'pages/Admin/Users/UserComponents/UserList/Formatters';
import ReqResTextarea from 'components/integrations/ReqResTextarea';
import { millisecondsToSecondsFormatter } from 'helpers/sf_utils';
import LoadingDashboardTableSkeleton from 'pages/Dashboard/LoadingDashboardTableSkeleton';

const FORMATTER_TYPE = {
    TEXT: 'text',
    DATE: 'date',
    SECONDS: 'seconds',
    REQ_DATA: 'req_data',
    LINK: 'link'
}

const ReqOrResTable = ({ row, sectionName, isBeautify, loading }) => {
    const requestColumns = [
        { key: 'id', text: 'ID', formatter: FORMATTER_TYPE.TEXT },
        { key: 'request_id', text: 'Request ID', formatter: FORMATTER_TYPE.TEXT },
        { key: 'action_name', text: 'Action Name', formatter: FORMATTER_TYPE.TEXT },
        { key: 'controller_name', text: 'Controller Name', formatter: FORMATTER_TYPE.TEXT },
        { key: 'created_at', text: 'Received', formatter: FORMATTER_TYPE.DATE },
        { key: 'elapsed_time', text: 'Elapsed Time(in sec)', formatter: FORMATTER_TYPE.SECONDS },
        { key: 'db_runtime', text: 'DB RunTime(in sec)', formatter: FORMATTER_TYPE.SECONDS },
        { key: 'jira_url', text: 'Jira Ticket', formatter: FORMATTER_TYPE.LINK },
        { key: 'request_params', text: 'Request Params', formatter: FORMATTER_TYPE.REQ_DATA },
        { key: 'request_header', text: 'Request Headers', formatter: FORMATTER_TYPE.REQ_DATA },
    ]
    const responseColumns = [
        { key: 'response', text: 'Response', formatter: FORMATTER_TYPE.REQ_DATA },
        { key: 'response_code', text: 'Response code', formatter: FORMATTER_TYPE.TEXT }
    ]

    const getDataFormatter = (key, value, formatter, isBeautify) => {
        switch (formatter) {
            case FORMATTER_TYPE.TEXT:
                return value;
            case FORMATTER_TYPE.DATE:
                return dateCreatedFormatter(value, {});
            case FORMATTER_TYPE.REQ_DATA:
                return value ? (
                    <ReqResTextarea
                        isBeautify={isBeautify}
                        key={key}
                        val={value}
                    />
                ) : (
                    <div className='dev-dashboard-req-res-body'>--</div>
                );
            case FORMATTER_TYPE.SECONDS:
                return millisecondsToSecondsFormatter(value);
            case FORMATTER_TYPE.LINK:
                return value ? <a href={value} className="text-sfblue" target="_blank">
                    View
                </a> : '--';
            default:
                return value;

        }
    }

    return (
        loading ?
            <LoadingDashboardTableSkeleton rows={6} cols={2} />
            :
            (
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Key</th>
                            <th scope="col">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (sectionName === SECTION_NAMES.REQUEST ? requestColumns : responseColumns).map((column) => {
                                return (
                                    <tr key={column.key} style={{ cursor: 'default' }}>
                                        <td className="text-capitalize font-weight-semibold">{column.text}</td>
                                        <td>
                                            {
                                                getDataFormatter(column.key, row?.[column.key], column.formatter, isBeautify) || '--'
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            )
    )
}

export default ReqOrResTable
